import { render, staticRenderFns } from "./finalButton.vue?vue&type=template&id=68bcd7d0&scoped=true"
import script from "./finalButton.vue?vue&type=script&lang=js"
export * from "./finalButton.vue?vue&type=script&lang=js"
import style0 from "./finalButton.vue?vue&type=style&index=0&id=68bcd7d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bcd7d0",
  null
  
)

export default component.exports